<template>
    <base-view :base-store="store" :title="$t('models.title')">
        <template #content>
            <crud-table
                class="ma-6"
                :after-create="[store.reload]"
                :base-store="store"
                :default-item="defaultItem"
                :table-headers="tableHeaders"
                :edit-title="$t('user.editTitle')"
                :create-btn-title="$t('user.createBtnTitle')"
                :create-title="$t('user.createTitle')"
                :delete-confirm-text="$t('remove')"
                :delete-abort-text="$t('cancel')"
                :delete-title="$t('user.deleteTitle')"
                suppress-delete-cancel-message
                suppress-delete-confirm-message
                suppress-edit-cancel-message
                suppress-edit-confirm-message
            >
                <template #deleteForm>
                    <p>{{ $t('user.deleteText') }}</p>
                </template>
                <template #editForm="{focusItem, outprops, onSave, onCancel}">

                    <v-row>
                        <text-field v-model="focusItem.username"
                                    prepend-icon="mdi-account-key"
                                    :hint="$t('user.username.hint')"
                                    :label="$t('user.username.lbl')"/>
                    </v-row>
                    <v-row>
                        <text-field v-model="focusItem.first_name"
                                    prepend-icon="mdi-account"
                                    :hint="$t('user.firstName.hint')"
                                    :label="$t('user.firstName.lbl')"/>
                    </v-row>
                    <v-row>
                        <text-field v-model="focusItem.last_name"
                                    prepend-icon="mdi-account"
                                    :hint="$t('user.lastName.hint')"
                                    :label="$t('user.lastName.lbl')"/>
                    </v-row>

                    <action-btn :confirm-text="$t('save')"
                                :cancel-text="$t('cancel')"
                                @save="onSave"
                                @cancel="onCancel"/>
                </template>
            </crud-table>
        </template>
    </base-view>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue"
import CrudTable from "@/components/generics/CrudTable/CrudTable.vue";
import BaseView from "@/views/BaseView.vue";
import ActionBtn from "@/components/generics/ActionBtn/ActionBtn.vue";
import TextField from "@/components/generics/TextField/TextField.vue";
import {useI18n} from "vue-i18n";
import {IUser} from "@/stores/UserStore/interfaces/IUser";
import {useUserStore} from "@/stores/UserStore/UserStore";


export default defineComponent({
    components: {
        TextField,
        ActionBtn,
        BaseView,
        CrudTable,
    },
    setup() {
        const store = useUserStore()

        const {t} = useI18n();
        const defaultItem: IUser = {
            id: null,
            username: '',
            first_name: null,
            last_name: null,
        }

        const tableHeaders = computed(() => [
            {title: t('user.table.username'), align: 'start', sortable: true, key: 'username'},
            {title: t('user.table.firstName'), align: 'start', sortable: true, key: 'first_name'},
            {title: t('user.table.lastName'), align: 'start', sortable: true, key: 'last_name'},
            {title: t('user.table.actions'), align: 'end', sortable: false, key: 'Actions'},
        ])

        return {
            // composable
            store,
            // const
            defaultItem,
            // computed
            tableHeaders
        }
    },
})
</script>
